import { memo } from 'react';

import { Shadows as BaseShadows } from '@spazious/dollhouse-engine';

export const Shadows = memo(BaseShadows);
